import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SavedSelection } from '../../models/land';

interface InitialState {
  currentClaim: SavedSelection | null;
  isCustomizing: boolean;
  from?: string | undefined;
}

interface ICustomizingClaimPayload {
  isCustomizing: boolean;
  data: SavedSelection;
  from?: string | undefined;
}

const initialState: InitialState = {
  currentClaim: null,
  from: undefined,
  isCustomizing: false,
};

const customizeMyLandSlice = createSlice({
  initialState,
  name: 'customize-my-land',
  reducers: {
    clearCurrentClaim: (state) => {
      state.currentClaim = initialState.currentClaim;
      state.isCustomizing = false;
    },
    setCurrentClaim: (
      state,
      action: PayloadAction<{
        claim: SavedSelection | null;
        from?: string | undefined;
      }>
    ) => {
      state.currentClaim = action.payload.claim;
      state.from = action.payload.from;
    },
    setIsCustomizing: (
      state,
      action: PayloadAction<ICustomizingClaimPayload>
    ) => {
      state.currentClaim = action.payload.data;
      state.isCustomizing = true;
    },
  },
});

export const { setCurrentClaim, clearCurrentClaim, setIsCustomizing } =
  customizeMyLandSlice.actions;

export default customizeMyLandSlice.reducer;
